import PageState from './state';

export default {
  getCommonPub(state: PageState): string {
    return state.commonPub || localStorage.getItem('commonPub') || '';
  }
};
